"use client";

import { useEffect } from "react";
import TagManager from "react-gtm-module";

declare global {
  interface Window {
    dataLayer: unknown[];
    trackAppDownload?: (platform: string) => void;
    trackGoldInterest?: (action: string) => void;
  }
}

export default function GoogleTagManager() {
  useEffect(() => {
    TagManager.initialize({ gtmId: "GTM-TCCHXXQR" });

    window.trackAppDownload = function (platform: string) {
      window.dataLayer.push({
        event: "app_download_click",
        platform,
        page_location: window.location.href,
        event_category: "engagement",
        event_label: "app_download",
      });
    };

    window.trackGoldInterest = function (action: string) {
      window.dataLayer.push({
        event: "gold_interest",
        action,
        event_category: "conversion",
        event_label: "gold_investment",
      });
    };

    window.dataLayer.push({
      event: "page_view",
      page_title: document.title,
      page_location: window.location.href,
      content_group1: "JustGold Website",
    });
  }, []);

  return (
    <noscript
      dangerouslySetInnerHTML={{
        __html: `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-TCCHXXQR" height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
      }}
    />
  );
}
